var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MTableCell',[_c('div',{staticClass:"m-table-cell-period-performance text text--xs"},[_c('span',[_vm._v(_vm._s(_vm.itemText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }